export default class BillingFields {
	constructor() {
		this.jsCheckboxInvoiceTerm = document.querySelector(".jsInvoiceTerm");
		this.jsBillingPersonType = document.querySelectorAll("input[name='billing_person_type']");
		this.jsBillingCompany = document.querySelector("#billing_company");
		this.jsBillingCompanyNip = document.querySelector("#billing_company_nip");
		this.events();

		if (this.jsBillingCompany && this.jsBillingPersonType && this.jsBillingCompany && this.jsBillingCompanyNip) {
			this.validateFields();
		}
	}

	events() {
		if (this.jsBillingPersonType) {
			this.jsBillingPersonType.forEach((checkbox) => {
				checkbox.addEventListener("click", this.validateFields.bind(this));
			});
		}
	}

	validateFields(event) {
		let value = "";
		this.jsBillingPersonType.forEach((input) => {
			if (input.checked) {
				value = input.value;
			}
		});

		if (!value) {
			this.jsBillingCompany.closest(".form__control").classList.add("form__control--hidden");
			this.jsBillingCompanyNip.closest(".form__control").classList.add("form__control--hidden");
			this.jsCheckboxInvoiceTerm.closest(".form__checkbox-label").classList.add("form__control--hidden");

			return;
		}

		if (value === "company") {
			this.jsBillingCompany.closest(".form__control").classList.remove("form__control--hidden");
			this.jsBillingCompanyNip.closest(".form__control").classList.remove("form__control--hidden");
			this.jsBillingCompany.closest(".form__control").classList.add("validate-required");
			this.jsBillingCompanyNip.closest(".form__control").classList.add("validate-required");

			if (this.jsCheckboxInvoiceTerm) {
				this.jsCheckboxInvoiceTerm.closest(".form__checkbox-label").classList.remove("form__control--hidden");
			}
		} else if (value === "person") {
			this.jsBillingCompany.closest(".form__control").classList.add("form__control--hidden");
			this.jsBillingCompanyNip.closest(".form__control").classList.add("form__control--hidden");
			this.jsBillingCompany.closest(".form__control").classList.remove("validate-required");
			this.jsBillingCompanyNip.closest(".form__control").classList.remove("validate-required");

			if (this.jsCheckboxInvoiceTerm) {
				this.jsCheckboxInvoiceTerm.closest(".form__checkbox-label").classList.add("form__control--hidden");
			}
		}
	}
}
